import { render } from "./RedirectCar.vue?vue&type=template&id=18cae53f"
import script from "./RedirectCar.vue?vue&type=script&lang=js"
export * from "./RedirectCar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/RedirectCar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18cae53f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18cae53f', __exports__)) {
    api.reload('18cae53f', __exports__)
  }
  
  module.hot.accept("./RedirectCar.vue?vue&type=template&id=18cae53f", () => {
    api.rerender('18cae53f', render)
  })

}


export default __exports__